var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgVideoAnyonePricingIcon = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_352_1315)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.00008 6.00002V11.5C1.00008 11.7652 1.10543 12.0196 1.29297 12.2071C1.48051 12.3947 1.73486 12.5 2.00008 12.5H12.0001C12.2653 12.5 12.5196 12.3947 12.7072 12.2071C12.8947 12.0196 13.0001 11.7652 13.0001 11.5V9.93752L15.2226 11.4194C15.3051 11.473 15.4017 11.501 15.5001 11.5C15.6327 11.5 15.7599 11.4473 15.8536 11.3536C15.9474 11.2598 16.0001 11.1326 16.0001 11V5.00002C15.9994 4.91005 15.9746 4.82193 15.928 4.74493C15.8815 4.66793 15.8151 4.60491 15.7357 4.56252C15.656 4.51978 15.5661 4.49948 15.4758 4.50377C15.3854 4.50806 15.2979 4.53679 15.2226 4.58689L13.0001 6.06564V4.50002C13.0001 4.2348 12.8947 3.98045 12.7072 3.79291C12.5196 3.60537 12.2653 3.50002 12.0001 3.50002H8.00008V4.50002H12.0001V11.5H2.00008V6.00002H1.00008ZM15.0001 10.0656L13.0001 8.73252V7.26752L15.0001 5.93752V10.0656Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.43737 1.07995C3.63066 0.557583 4.36949 0.557574 4.56279 1.07995L5.19949 2.80061L6.92015 3.43731C7.44251 3.6306 7.44252 4.36943 6.92015 4.56273L5.19949 5.19943L4.56279 6.92009C4.3695 7.44245 3.63066 7.44246 3.43737 6.92009L2.80067 5.19943L1.08001 4.56273C0.557644 4.36944 0.557635 3.6306 1.08001 3.43731L2.80067 2.80061L3.43737 1.07995ZM4.00008 2.44079L3.67469 3.32014C3.61392 3.48437 3.48443 3.61386 3.3202 3.67463L2.44085 4.00002L3.3202 4.32541C3.48443 4.38618 3.61392 4.51566 3.67469 4.6799L4.00008 5.55925L4.32547 4.6799C4.38624 4.51566 4.51572 4.38618 4.67996 4.32541L5.55931 4.00002L4.67996 3.67463C4.51572 3.61386 4.38624 3.48437 4.32547 3.32014L4.00008 2.44079Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_352_1315"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgVideoAnyonePricingIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/video-anyone-pricing-icon.56ec28b5132f32f73e126ef2cb769929.svg";